// extracted by mini-css-extract-plugin
export default {"password":"styles_password__CvgvG","formItem":"styles_formItem__nG3mM"};